"use client";
import classNames from "classnames";
// import { Stack } from "@fastlooptech/layout-components";
import { Heading, Body, Display } from "@/client/foundations/Typography";
import { spaceUnit } from "@/helpers/utils.helper";
import { Stack } from "@/layouts/LayoutComponents";
import { ReactNode } from "react";

export interface ColumnTextProps {
  "data-test-id"?: string;
  /**
   * The ColumnText className.
   * @type {string}
   */
  className?: string;
  /**
   * The hero title of the ColumnText.
   * @type string
   * @optional
   */
  heroTitle?: string;
  /**
   * The hero subtitle of the ColumnText.
   * @type string
   * @optional
   */
  heroSubtitle?: string;
  /**
   * The title of the ColumnText.
   * @type string
   * @optional
   */
  title?: string;
  /**
   * The description of the ColumnText.
   * @type string
   * @optional
   */
  subtitle?: string;
  /**
   * The first text block of the ColumnText.
   * @type {value: string, bold: boolean}[]
   * @optional
   */
  textBlocks?: { value: string; bold: boolean }[];
  /**
   * The second text block of the ColumnText.
   * @type string
   * @optional
   */
  secondTextBlock?: string;
  /**
   * Define the horizontal alignment of the ColumnText.
   * @type boolean
   * @optional
   */
  centered?: boolean;
  /**
   * The optional cta of the ColumnText.
   * @type ReactNode
   * @optional
   */
  cta?: ReactNode;
}

export function ColumnText(props: ColumnTextProps) {
  return (
    <Stack
      data-test-id={props["data-test-id"]}
      column
      gap={spaceUnit * 4}
      vAlignContent="center"
      hAlignContent={props.centered ? "center" : "left"}
      className={classNames(props.className)}
    >
      {props.heroTitle ? (
        <Display className="self-start break-words" size="xl" animated={true}>
          {props.heroTitle}
        </Display>
      ) : null}
      {props.heroSubtitle ? (
        <Display className="self-start break-words" size="m" animated={true}>
          {props.heroSubtitle}
        </Display>
      ) : null}
      {props.title ? (
        <Heading size="m" className="self-start" animated={true}>
          {props.title}
        </Heading>
      ) : null}
      {/* {props.subtitle ? <Heading size="m" animated={true}>{props.subtitle}</Heading> : null} */}
      {props.textBlocks
        ? props.textBlocks.map((textBlock, index) => (
          <Body key={`ColumnText-${index}`} size="m" bold={textBlock.bold} animated={true}>
            {textBlock.value}
          </Body>
        ))
        : null}
      {props.cta}
    </Stack>
  );
}
